let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2nFSk")).then(() => parcelRequire('36Q2c'));